import styles from '../../styles/Home.module.scss'
import Image from 'next/image';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { useEffect, useState } from 'react';
import { usePlacesWidget } from "react-google-autocomplete";
import Router from 'next/router';
import * as gtag from '../../lib/gtag'
import * as fbq from '../../lib/fbq'
import { getSpaceValidation, handleEmailValidation, handlePhoneNumberValidation } from "../../utils/validationUtil";
import { useAppDispatch } from '../../app/hooks';
import { assignFullName, assignEmail, assignAccoId, assignOwnerId, assignEstimation, assignBedrooms } from '../../features/accoDetails/accoDetailsSlice';
import { Brand } from '../enums/EnumDefinition';
import ReactMarkdown from 'react-markdown'
import { getPushURL, returnImageURL } from '../../utils/getURLs';
import { RequiredFieldText, ValidHouseSize, ValidFullName, ValidEmailAddress, ValidPhoneNumber, AcceptTermsAndConditions, ValidHouseSizeRange } from '../../constants/appConstants/HoLeadErrors';
import { getParamByISO } from 'iso-country-currency';
import 'react-toastify/dist/ReactToastify.css';
import { BackendBaseURL } from '../../constants/appConstants/Urls';
import LinkRenderer from '../markdownComponents/LinkRenderer';
import { apiErrorHandling, processResponse, unexpectedError } from '../../utils/errors';
import { GET, googleAPI, POST } from '../../apiCall/api';
import { getZipCode, getCountry, handleExPhoneNumber, handlePhoneNumber } from '../../utils/handleInputChange';
import { localWiseBaseURL } from '../../utils/ternaryConditionUtil';

const handleGoogleAnalytics = (category: string, action: string, label: string) => {
    gtag.event({
        category: category,
        action: action,
        label: label,
    });
}
const handleFaceBookPixel = (eventName: string, category: string, action: string, label: string) => {
    fbq.event({
        eventName: eventName,
        category: category,
        action: action,
        label: label,
    });
}

let numberOfBedroomsOptions: string[] = [];

const BASE_HOST = BackendBaseURL.BACKEND_BASE_URL;

const LeadRegisterSE = ({ Ref, stepNumber, dataForHomePage }: { Ref: any, stepNumber: number, dataForHomePage: any }) => {

    const basePathStep1 = dataForHomePage?.firstStep;
    const basePathStep2 = dataForHomePage?.secondStep;
    const basePath = dataForHomePage;

    const dispatch = useAppDispatch();
    // For Input
    const [formmatedAddress, setFormmatedAddress] = useState('');
    const [addressData, setAddressData] = useState<object>();
    const [addressLatLonData, setAddressLatLonData] = useState({ lat: 0, lng: 0 });
    const [bedRooms, setBedRooms] = useState('');
    const [haveProperty, setHaveProperty] = useState<boolean>();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumberValue, setPhoneNumberValue] = useState('');
    const [phoneCountryCode, setPhoneCountryCode] = useState('');
    const [phoneNumberFormat, setPhoneNumberFormat] = useState('');
    const [formattedPhoneNumber, setFormattedPhoneNumber] = useState('');
    const [phoneDialCode, setPhoneDialCode] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [propertyType, setPropertyType] = useState('');
    const [houseSize, setHouseSize] = useState('');
    const [acceptAgreement, setAcceptAgreement] = useState<boolean>(false);
    const [country, setCountry] = useState('');
    const [currency, setCurrency] = useState('');
    const [exPhoneNumber, setExPhoneNumber] = useState(handlePhoneNumber('se'));

    // errors
    const [showErrorAddress, setShowErrorAddress] = useState<boolean>(false);
    const [showErrorBedroom, setShowErrorBedroom] = useState<boolean>(false);
    const [showErrorHaveProperty, setShowErrorHaveProperty] = useState<boolean>(false);
    const [showErrorPropertyType, setShowErrorPropertyType] = useState<boolean>(false);
    const [showErrorHouseSize, setShowErrorHouseSize] = useState<boolean>(false);
    const [showOutOfRangeErrorHouseSize, setOutOfRangeErrorHouseSize] = useState<boolean>(false);
    const [showErrorFullName, setShowErrorFullName] = useState<boolean>(false);
    const [showErrorEmail, setShowErrorEmail] = useState<boolean>(false);
    const [showErrorPhone, setShowErrorPhone] = useState<boolean>(false);
    const [showErrorAgreement, setShowErrorAgreement] = useState<boolean>(false);

    const [tooltipVisibility, setTooltipVisibility] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const bedRoomsInNumber = parseInt(bedRooms);
    const zipCodeWithOutSpace = zipCode.replace(/ /, "");
    const zipCodeInNumber = parseInt(zipCodeWithOutSpace);
    const houseSizeInNumber = parseFloat(houseSize);

    const [screenWidth, setScreenWidth] = useState<number>(0);
    useEffect(() => {
        setScreenWidth(document.body.clientWidth);
    }, [])

    useEffect(() => {
        for (let index = 1; index < 51; index++) {
            if (index === 1) numberOfBedroomsOptions.push(index + ' ' + basePathStep1?.bedroom);
            else numberOfBedroomsOptions.push(index + ' ' + basePathStep1?.bedrooms);
        }
    }, [])

    const { ref } = usePlacesWidget<HTMLInputElement>({
        apiKey: 'AIzaSyC4lRVlngpcZVCA1O_hy59CLs1H3oHVAtY',
        onPlaceSelected: (place) => handleOnPlaceSelected(place),
        options: {
            types: ["address"],
            componentRestrictions: { country: ["dk", "no", "se"] },
        },
    });

    const handleOnPlaceSelected = (place: any) => {
        setShowErrorAddress(false);
        googleAPI(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${place.place_id}&key=AIzaSyA0bnUjKyY0Nd3p0KPBsIQwenb3d1yyESw`)
            .then(apiResponse => apiResponse.json())
            .then((response) => {
                if (response.status === 'OK') {
                    setAddressData(response.results[0]);
                    setAddressLatLonData(response.results[0].geometry.location);
                    setFormmatedAddress(response.results[0].formatted_address);
                    handleZipCode(response.results[0].address_components);
                    handleCountryWithCurrency(response.results[0].address_components);
                }
            })
            .catch(err => {
                console.log(err);
                unexpectedError("se");
            })
    }

    const handleZipCode = (address: any) => {
        const postalCode = getZipCode(address);
        if (postalCode !== -1) setZipCode(postalCode);
        else setZipCode('');
    }

    const handleCountryWithCurrency = (address: any) => {
        const countryName = getCountry(address);
        if (countryName !== -1) setCountry((countryName)?.toLowerCase());
        const currencyUpperCase = getParamByISO(countryName, 'currency');
        setCurrency(currencyUpperCase?.toLowerCase());

    }

    const handleNumberOfBedRoomsChange = (e: { target: { value: string } }) => {
        setBedRooms(e.target.value);
        setShowErrorBedroom(false);
    }
    const handlePropertyTypeChange = (e: { target: { value: string } }) => {
        setPropertyType(e.target.value);
        setShowErrorPropertyType(false);
    }

    const handleFullNameOnChange = (e: { target: { value: string } }) => {
        const result = e.target.value.replace(/[^a-z|À-Ö|Ø-ö| |ø-ÿ]/gi, '');
        setFullName(result);
        setShowErrorFullName(false);
    }
    const handlePropertySizeOnChange = (e: { target: { value: string } }) => {
        const result = e.target.value.replace(/[^0-9| ]/g, '');
        setHouseSize(result);
        setShowErrorHouseSize(false);
    }

    const handleEmailOnChange = (e: { target: { value: string } }) => {
        setEmail(e.target.value);
        setShowErrorEmail(false);
    }

    const handlePhoneNumberOnChange = (value: string, data: any, event: any, formattedValue: string) => {
        setExPhoneNumber(handleExPhoneNumber(data));
        setPhoneNumberValue(value);
        setPhoneCountryCode(data.countryCode);
        setPhoneNumberFormat(data?.format);
        setPhoneDialCode(data.dialCode);
        setFormattedPhoneNumber(formattedValue);
        setShowErrorPhone(false);
    }
    const handleAgreementOnChange = () => {
        if (acceptAgreement === false) {
            setAcceptAgreement(true);
            setShowErrorAgreement(false);
        } else {
            setAcceptAgreement(false);
            setShowErrorAgreement(true);
        }
    }

    const handleBtnOnClick = async (type: number) => {
        if (type === 1) {
            let errorStatus = false;
            if (formmatedAddress.trim() === '') {
                setShowErrorAddress(true);
                errorStatus = true;
            }
            if (bedRooms.trim() === '') {
                setShowErrorBedroom(true);
                errorStatus = true;
            } else {
                setShowErrorBedroom(false);
            }
            if (houseSize.trim() === '') {
                setShowErrorHouseSize(true);
                errorStatus = true;
            } else if (houseSizeInNumber < 1 || houseSizeInNumber > 32765) {
                setOutOfRangeErrorHouseSize(true);
                setShowErrorHouseSize(false);
                errorStatus = true;
            } else {
                setOutOfRangeErrorHouseSize(false);
                setShowErrorHouseSize(false);
            }
            if (propertyType.trim() === '') {
                setShowErrorPropertyType(true);
                errorStatus = true;
            } else {
                setShowErrorPropertyType(false);
            }
            if (haveProperty === undefined) {
                setShowErrorHaveProperty(true);
                errorStatus = true;
            } else {
                setShowErrorHaveProperty(false);
            }

            if (errorStatus === false) {
                setLoading1(true);
                dispatch(assignBedrooms(bedRooms)); //assign bedrooms value to redux variable
                if (typeof window !== 'undefined')
                    window.sessionStorage.setItem('homepagestep1', JSON.stringify({
                        formmatedAddress,
                        addressLatLonData,
                        bedRoomsInNumber,
                        haveProperty,
                        propertyType,
                        zipCodeInNumber,
                        zipCode: zipCode === "" ? null : zipCode,
                        houseSizeInNumber,
                        addressData,
                        country,
                        currency
                    }))

                handleGoogleAnalytics('holead:rental_calculation', 'calculate rental button', 'property information');
                handleFaceBookPixel('Contact', 'holead:rental_calculation', 'calculate rental button clicked', 'property information (step1)')
                if (typeof window !== 'undefined')
                    Router.push('/step-2', getPushURL(window.location.hostname, '/step-2'));
            }
        }
        else {
            let errorStatus = false;
            if (fullName.trim() === '' || getSpaceValidation(fullName) === false) {
                setShowErrorFullName(true);
                errorStatus = true;
            } else {
                setShowErrorFullName(false);
            }
            if (email.trim() === '' || !handleEmailValidation(email)) {
                setShowErrorEmail(true);
                errorStatus = true;
            } else {
                setShowErrorEmail(false);
            }
            if (phoneNumberValue.trim() === '' || !handlePhoneNumberValidation(formattedPhoneNumber, phoneNumberFormat)) {
                setShowErrorPhone(true);
                errorStatus = true;
            } else {
                setShowErrorPhone(false);
            }
            if (acceptAgreement === false) {
                setShowErrorAgreement(true);
                errorStatus = true;
            } else {
                setShowErrorAgreement(false);
            }

            if (errorStatus === false) {
                setLoading2(true);
                dispatch(assignFullName(fullName)); //assign full name value to redux variable
                dispatch(assignEmail(email)); //assign email value to redux variable
                if (typeof window !== 'undefined') {
                    const step1Data = JSON.parse(window.sessionStorage.getItem('homepagestep1') || '{}');

                    const dataObjectForValuationRequest = {
                        "lat": step1Data?.addressLatLonData?.lat,
                        "country": step1Data?.country,
                        "brand": Brand.dc,
                        "currency": step1Data?.currency,
                        "long": step1Data?.addressLatLonData?.lng,
                        "no_bedrooms": step1Data?.bedRoomsInNumber,
                        "house_size": step1Data?.houseSizeInNumber,
                        "apartment": step1Data?.propertyType === basePathStep1?.propertyTypes[0] ? true : false
                    }
                    window.sessionStorage.setItem('valuationRequestPayload', JSON.stringify(dataObjectForValuationRequest));
                    // handle session login request
                    await GET(`${BASE_HOST}/api/session/login?userMail=${email}`)
                        .then((response) => {
                            if (response.status === 200) {
                                window.sessionStorage.setItem('sessionId', JSON.stringify({
                                    "sessionId": response.headers.get('JSESSIONID')
                                }));
                                window.sessionStorage.setItem('csrfToken', JSON.stringify({
                                    "csrfToken": response.headers.get('x-csrf-token')
                                }));
                            } else {
                                window.sessionStorage.clear();
                                Router.push('/', getPushURL(window.location.hostname, '/'));
                            }
                        })
                    await handleValuationRequest(dataObjectForValuationRequest);
                    handleGoogleAnalytics('holead:rental_calculation', 'calculate rental button', 'contact details');
                    handleFaceBookPixel('Lead', 'holead:rental_calculation', 'calculate rental button clicked', 'property information (step2)');
                    const step2Data = JSON.parse(window.sessionStorage.getItem('homepagestep2') || '{}');
                    if (Object.keys(step2Data).length === 0)
                        window.sessionStorage.clear();
                    else
                        Router.push('/form/' + 1, getPushURL(window.location.hostname, '/form/1'));
                }
            }
        }
    }

    const handleValuationRequest = async (payload: any) => {
        if (typeof window !== 'undefined') {
            let csrfToken = JSON.parse(window.sessionStorage.getItem('csrfToken') || '');
            let sessionId = JSON.parse(window.sessionStorage.getItem('sessionId') || '');
            let headers = {
                'Content-type': 'application/json; charset=UTF-8',
                'Content-Encoding': 'gzip',
                'x-csrf-token': csrfToken?.csrfToken,
                'JSESSIONID': sessionId?.sessionId
            }
            await POST(`${BASE_HOST}/api/lead-data/estimate-valuation`, payload, headers)
                .then((apiResponse) => apiErrorHandling(apiResponse, 'se'))
                .then(correctApiResponse => correctApiResponse.json())
                .then(response => {
                    dispatch(assignEstimation(response['data'].estimate));
                    return response['data'].estimate;
                })
                .then(async (estimate_val) => {
                    const step1Data = JSON.parse(window.sessionStorage.getItem('homepagestep1') || '{}');
                    const utmParams = JSON.parse(window.sessionStorage.getItem('utmParams') || '{}');
                    const dataForInsertHouse = {
                        "extra": {
                            "isReferral": utmParams?.is_referral,
                            "utmSource": utmParams?.utmSource,
                            "utmCampaign": utmParams?.utmCampaign,
                            "utmMedium": utmParams?.utmMedium,
                            "utmTerm": utmParams?.utmTerm,
                            "referral-source": utmParams?.referral_source,
                            "referral-code": utmParams?.referral_code,
                            "url": localWiseBaseURL('se')
                        },
                        "acco_address": step1Data.formmatedAddress,
                        "lat": step1Data.addressLatLonData.lat,
                        "lon": step1Data.addressLatLonData.lng,
                        "acco_room": step1Data.bedRoomsInNumber,
                        "ho_name": fullName,
                        "ho_email": email,
                        "brand": Brand.dc,
                        "ho_phone": '+' + phoneNumberValue,
                        "acco_zip_code": step1Data.zipCodeInNumber,
                        "acco_zip_code_string": step1Data.zipCode,
                        "valuation": estimate_val,
                        "currency": step1Data?.currency,
                        "country": step1Data?.country,
                        "acco-location-search-data": step1Data.addressData,
                        "acco_pool": 0, //this field is mandatory in backend so we are giving hardcoded value here, and we are changing this value in upcoming forms
                    }
                    await POST(`${BASE_HOST}/api/lead-data/insert-house`, dataForInsertHouse, headers)
                        .then((apiResponse) => apiErrorHandling(apiResponse, 'se'))
                        .then(correctApiResponse => processResponse(correctApiResponse))
                        .then(response => {
                            if (!response['success'])
                                return;
                            dispatch(assignAccoId(response['data'].accoId));
                            dispatch(assignOwnerId(response['data'].ownerId));
                            window.sessionStorage.setItem('homepagestep2', JSON.stringify({
                                fullName,
                                email,
                                "phoneNumber": '+' + phoneNumberValue,
                                "ownerId": response['data'].ownerId,
                                "accoId": response['data'].accoId,
                            }))
                            window.sessionStorage.setItem('estimation_value', JSON.stringify({
                                "estimation": estimate_val,
                            }))
                        })
                        .catch(err => {
                            console.log(err);
                            unexpectedError("se");
                        })
                })
                .catch(err => {
                    console.log(err);
                    unexpectedError("se");
                })
        }
    }

    return (
        <div>
            <div ref={Ref} data-testid='lead-register-component' className={styles["leadRegister"]} id={"section-lead-register"}>
                <Image priority src={returnImageURL(basePath?.backgroundImage?.data[0]?.attributes, screenWidth)} objectPosition={'top'} layout="fill" objectFit="cover" quality={100} alt='se-background' />
                <div className={stepNumber === 1 ? styles["page-hero-content"] : styles["page-hero-content-overlay"]} >
                    <div className={styles["lead-register-container"]}>
                        <div className={styles["row"]}>
                            <div className={styles["col-1"]}>
                                {stepNumber === 1 && <h1 className={styles["lead-register-header"]}>{basePathStep1?.heading}</h1>}
                                {stepNumber === 2 && <h1 className={styles["lead-register-header"]}>{basePathStep2?.heading}</h1>}
                            </div>
                            <div className={styles["col-2"]}>
                                <form action="" className={styles["form-leads-register"]} id={"form-leads-register"} name={"form-leads-register"}>
                                    {/* <!-- Form step: 1 -->
                                <!-- wwwdk wwwno --> */}
                                    {stepNumber === 1 &&
                                        <><div data-testid='form-step-1' className={styles["leads-form-step"]} data-step={"1"}>
                                            <div className={styles["form-title"]}>
                                                <span className={styles["form-header"]}>{basePathStep1?.subHeading}</span>
                                                <span className={styles["form-badge-step-se"]}>{basePathStep1?.stepNumber}</span>
                                            </div>

                                            <div className={`${styles["form-group"]} ${styles["form-group-private-pool"]}`}>
                                                <div className={styles["private-pool"]}>
                                                    <div className={styles["private-pool-question"]}>{basePathStep1?.havePropertyQuestion}</div>
                                                    <div className={styles["private-pool-options"]}>

                                                        <label onFocus={() => handleGoogleAnalytics("holead:property_information", "haveProperty", "Yes")} data-testid='yes-btn' onClick={() => { setHaveProperty(true); setShowErrorHaveProperty(false); }} className={styles["radio-btn-container"]} >{basePathStep1?.yes}
                                                            <input data-testid='yes' type="radio" id="haveProperty-1" name="haveProperty" value="Yes" />
                                                            <span className={styles["checkmark"]}></span>
                                                        </label>
                                                        <label onFocus={() => handleGoogleAnalytics("holead:property_information", "haveProperty", "No")} data-testid='no-btn' onClick={() => { setHaveProperty(false); setShowErrorHaveProperty(false); }} className={styles["radio-btn-container"]} >{basePathStep1?.no}
                                                            <input data-testid='no' type="radio" id="haveProperty-2" name="haveProperty" value="No" />
                                                            <span className={styles["checkmark"]}></span>
                                                        </label>


                                                    </div>
                                                </div>
                                                {showErrorHaveProperty && <div className={styles["text-error"]} id="text-error-haveProperty">{RequiredFieldText.se}</div>}
                                            </div>
                                            <div className={styles["form-group"]}>
                                                <select onFocus={() => handleGoogleAnalytics("holead:property_information", "property type", "")} data-testid='propertyType' id="propertyType" name="propertyType" onChange={(e) => handlePropertyTypeChange(e)
                                                } className={`${styles["form-select"]} ${showErrorPropertyType ? styles["form-control-error"] : styles["form-control"]}`} required>
                                                    <option value="">{basePathStep1?.propertyTypeQuestion}</option>
                                                    {basePathStep1?.propertyTypes.map((value: string, index: number) => {
                                                        return <option key={index + 1} value={value}>{value}</option>;
                                                    })}
                                                </select>
                                                {showErrorPropertyType && <div className={styles["text-error"]} id="text-error-propertyType">{RequiredFieldText.se}</div>}
                                            </div>

                                            <div className={styles["form-group"]}>
                                                <input
                                                    autoComplete='off'
                                                    name='acco-address'
                                                    ref={ref}
                                                    className={`${styles["pac-target-input"]} ${showErrorAddress ? styles["form-control-error"] : styles["form-control"]}`}
                                                    id={"acco-location"}
                                                    placeholder={basePathStep1?.address}
                                                    onFocus={() => handleGoogleAnalytics("holead:property_information", "raw_query_address", "")}
                                                />
                                                {showErrorAddress && <div className={styles["text-error"]} id={"text-error-acco-location"}>{RequiredFieldText.se}</div>}
                                                <input type="hidden" name="acco-location-search-data" id="acco-location-search-data" value={JSON.stringify(addressData)}></input>
                                                <input type="hidden" name="acco-location-search-latlon" id="acco-location-search-latlon" value={JSON.stringify(addressLatLonData)}></input>
                                            </div>

                                            <div className={styles["form-group"]}>
                                                <select onFocus={() => handleGoogleAnalytics("holead:property_information", "number of bedrooms", "")} data-testid='bedrooms' id="number-of-bedrooms" name="number-of-bedrooms" onChange={(e) => handleNumberOfBedRoomsChange(e)
                                                } className={`${styles["form-select"]} ${showErrorBedroom ? styles["form-control-error"] : styles["form-control"]}`} required>
                                                    <option value="">{basePathStep1?.numberOfBedrooms}</option>
                                                    {numberOfBedroomsOptions.map((value, index) => {
                                                        return <option key={index + 1} value={index + 1}>{value}</option>;
                                                    })}
                                                </select>
                                                {showErrorBedroom && <div className={styles["text-error"]} id="text-error-number-of-bedrooms">{RequiredFieldText.se}</div>}
                                            </div>

                                            <div className={styles["form-group"]}>
                                                <input onFocus={() => handleGoogleAnalytics("holead:property_information", "house-size", "")} data-testid='house-size' type="text" className={showErrorHouseSize ? styles["form-control-error"] : styles["form-control"]} id={"house-size"} name={"house-size"} onChange={(e) => handlePropertySizeOnChange(e)} value={houseSize} placeholder={basePathStep1?.propertySizeQuestion} />
                                                {showErrorHouseSize && <div className={styles["text-error"]} id={"text-error-house-size"}>{ValidHouseSize.se}</div>}
                                                {showOutOfRangeErrorHouseSize && <div className={styles["text-error"]} id={"text-error-house-size-out-of-range"}>{ValidHouseSizeRange.se}</div>}
                                            </div>
                                        </div>
                                            <button data-testid='submit-step-1-btn' onClick={(e) => handleBtnOnClick(1)} type='button' className={loading1 ? styles["btn-loading"] : styles["btn"]} disabled={loading1}>
                                                {loading1 && <div className={styles["btn-loading-container"]}>
                                                    <div>{basePathStep1?.buttonLoadingTitle}</div>
                                                    <div className={styles["loader"]}></div>
                                                </div>}
                                                {!loading1 && <div>{basePathStep1?.buttonTitle}</div>}
                                            </button>
                                        </>
                                    }
                                    {/* <!-- Form step: 2 -->
                                <!-- wwwdk wwwno --> */}
                                    {stepNumber === 2 &&
                                        <>
                                            <div data-testid='form-step-2' className={styles["leads-form-step"]} data-step={"2"}>
                                                <div className={styles["form-title"]}>
                                                    <span className={styles["form-header"]}>{basePathStep2?.subHeading}</span>
                                                    <span className={styles["form-badge-step-se"]}>{basePathStep2?.stepNumber}</span>
                                                </div>

                                                <div className={styles["form-group"]}>
                                                    <input onFocus={() => handleGoogleAnalytics("holead:property_information", "full name", "")} data-testid='name' type="text" className={showErrorFullName ? styles["form-control-error"] : styles["form-control"]} id={"ho-name"} name={"ho-name"} onChange={(e) => handleFullNameOnChange(e)} value={fullName} placeholder={basePathStep2?.fullName} maxLength={85} />
                                                    {showErrorFullName && <div className={styles["text-error"]} id={"text-error-ho-name"}>{ValidFullName.se}</div>}
                                                </div>

                                                <div className={styles["form-group"]}>
                                                    <input onFocus={() => handleGoogleAnalytics("holead:property_information", "email", "")} data-testid='email' type="email" className={showErrorEmail ? styles["form-control-error"] : styles["form-control"]} id={"email"} name={"email"} onChange={(e) => handleEmailOnChange(e)} value={email} placeholder={basePathStep2?.email} />
                                                    {showErrorEmail && <div className={styles["text-error"]} id={"text-error-email"}>{ValidEmailAddress.se}</div>}
                                                </div>

                                                <div className={`${styles["form-group"]} ${styles["phone-number-container"]}`}>
                                                    <PhoneInput
                                                        inputProps={{
                                                            name: 'phone',
                                                            autoFocus: false
                                                        }}
                                                        containerClass={styles["react-tel-input"]}
                                                        inputClass={styles["form-control-phone"]}
                                                        placeholder={basePathStep2?.telephone}
                                                        country={"se"}
                                                        onFocus={() => {
                                                            setTooltipVisibility(false);
                                                            handleGoogleAnalytics("holead:property_information", "phone number", "");
                                                        }}
                                                        value={phoneNumberValue}
                                                        onChange={(value, data, event, formattedValue) => handlePhoneNumberOnChange(value, data, event, formattedValue)}>
                                                    </PhoneInput>

                                                    {showErrorPhone && <div className={styles["text-error"]} >{ValidPhoneNumber.se} {exPhoneNumber}</div>}

                                                    <input type="hidden" name="phone-country-code" id="phone-country-code" value={phoneCountryCode}></input>
                                                    <input type="hidden" name="phone-number" id="phone-number" value={formattedPhoneNumber}></input>
                                                    <input type="hidden" name="phone-dial-code" id="phone-dial-code" value={phoneDialCode}></input>
                                                    <input type="hidden" name="phone-number-valid" id="phone-number-valid" value=""></input>
                                                    <input type="hidden" name="phone-number-example" id="phone-number-example" value=""></input>

                                                    {tooltipVisibility && <div className={styles["fake-tooltip"]}>
                                                        <div className={styles["arrow"]}></div>
                                                        <div className={styles["fake-tooltip-inner"]}>
                                                            <div className={styles["fake-tooltip-text"]}>
                                                                <span className={styles["icon-info-gold"]}>
                                                                    <Image src={returnImageURL(basePathStep2?.infoIcon?.data[0]?.attributes, screenWidth)} width={22} height={22} alt={'info-gold-icon'} />
                                                                </span>
                                                                {basePathStep2?.tooltip}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>


                                                <div className={`${styles["form-group"]} ${styles["form-group-accept-terms"]}`} id="form-group-accept-terms">
                                                    <div className={styles["custom-switch"]}>
                                                        <label className={styles["switch"]}>
                                                            <input onFocus={() => handleGoogleAnalytics("holead:property_information", "accept terms&condition clicked", "")} type="checkbox" className={styles["switch-input"]} checked={acceptAgreement} onChange={handleAgreementOnChange} required />
                                                            <div className={`${styles["slider"]} ${styles["slider-round"]}`}></div>
                                                            <div className={styles["accept-terms-text"]}>
                                                                <ReactMarkdown components={{ a: LinkRenderer }}>{basePathStep2?.termsAndConditions}</ReactMarkdown>
                                                            </div>

                                                        </label>
                                                    </div>
                                                    <div className={styles["text-error"]} id="text-error-can-contact"></div>
                                                    {showErrorAgreement && <div className={styles["text-error"]} >{AcceptTermsAndConditions.se}</div>}

                                                </div>
                                            </div>
                                            <button onClick={(e) => handleBtnOnClick(2)} type='button' className={loading2 ? styles["btn-loading"] : styles["btn"]} disabled={loading2}>
                                                {loading2 && <div className={styles["btn-loading-container"]}>
                                                    <div>{basePathStep2?.buttonLoadingTitle}</div>
                                                    <div className={styles["loader"]}></div>
                                                </div>}
                                                {!loading2 && <div>{basePathStep2?.buttonTitle}</div>}
                                            </button>
                                        </>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>


    );
}

export default LeadRegisterSE;